import { useEffect } from "react";

type UsePreventUnloadParams = {
	shouldPrevent: boolean;
	message: string;
};

/**
 * Hook to prevent browser navigation/refresh with beforeunload event
 * Shows browser's native confirmation dialog when user tries to leave
 */
export const usePreventUnload = ({ shouldPrevent, message }: UsePreventUnloadParams) => {
	useEffect(() => {
		if (!shouldPrevent) {
			return;
		}

		const handleBeforeUnload = (event: BeforeUnloadEvent) => {
			event.preventDefault();
			event.returnValue = message;
			return message;
		};

		window.addEventListener("beforeunload", handleBeforeUnload);

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, [shouldPrevent, message]);
};

export default usePreventUnload;
